import React, { FC, useEffect, useState } from "react";

import Image, { ICONS } from "../Image";
import Typography from "../Typography";

import { Col, Row } from "../Flex";

import useRefs from "helpers/hooks/useRefs";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { useMediaQuery } from "context/media/MediaContext";

import { WizardProps } from "./Wizard.constants";
import {
  StyledCircle,
  StyledInnerContainer,
  StyledLine,
  StyledOuterContainer,
  StyledWizardContainer,
} from "./Wizard.styles";
import ComponentScrollbar from "../ComponentScrollbar";

const Wizard: FC<WizardProps> = ({ currentPage, wizardStepTitles }) => {
  const { getRefs, setRef } = useRefs<HTMLDivElement>();

  const { isMobile } = useMediaQuery();

  const [innerContainerWidths, setInnerContainerWidths] = useState<number[]>(
    []
  );

  const stepRefs = getRefs();

  const outerContainerWidth = innerContainerWidths.reduce(
    (previous: number, current: number) => previous + current,
    0
  );

  const scrollOffSet = innerContainerWidths
    .slice(0, currentPage)
    .reduce((previous: number, current: number) => previous + current, 0);

  useEffect(() => {
    if (stepRefs?.current) {
      stepRefs?.current?.forEach((element) => {
        setInnerContainerWidths((prevState: number[]) => [
          ...prevState,
          element.clientWidth,
        ]);
      });
    }
  }, [stepRefs]);

  type VisibleScrollProp = { children: React.ReactNode };
  const VisibleScroll: FC<VisibleScrollProp> = ({ children }) =>
    isMobile ? (
      <ComponentScrollbar>{children}</ComponentScrollbar>
    ) : (
      <>{children}</>
    );

  return (
    <VisibleScroll>
      <StyledWizardContainer outerContainerWidth={outerContainerWidth}>
        <StyledOuterContainer>
          <Row backgroundColor={DIGIPOSTHEME.colors.secondaryWhite} noMargin>
            {wizardStepTitles?.map((title, index) => (
              <StyledInnerContainer
                key={title}
                ref={(element) => {
                  if (element) setRef(element, index);
                }}
              >
                {currentPage > index ? (
                  <Image
                    alt='Tick Icon'
                    height='20px'
                    margin='0 5px 0 0'
                    srcSet={ICONS.TICK}
                    width='20px'
                  />
                ) : (
                  <StyledCircle isNextStep={currentPage >= index}>
                    {index + 1}
                  </StyledCircle>
                )}

                <Col>
                  <Typography
                    color={
                      currentPage >= index
                        ? DIGIPOSTHEME.colors.secondaryBlack
                        : DIGIPOSTHEME.colors.secondaryGrayPrimary
                    }
                    margin='2px 7px'
                    size='12px'
                    variant='span'
                    weight='500'
                  >
                    {title}
                  </Typography>
                </Col>

                {index !== wizardStepTitles.length - 1 && (
                  <StyledLine isNextStep={currentPage >= index} />
                )}
              </StyledInnerContainer>
            ))}
          </Row>
        </StyledOuterContainer>
      </StyledWizardContainer>
    </VisibleScroll>
  );
};

export default Wizard;
